import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export const WhatIsInside = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const tomos = [{
    num: 1,
    title: 'Qué es el barre y por qué tu estudio lo necesita ahora',
    items: ['El momento del barre en Argentina', 'Barra vs Pilates: diferencias y complementos', 'Los tres modelos de negocio para sumar barre', 'Lo que necesitás saber antes de dar la primera clase', 'Checklist de arranque']
  }, {
    num: 2,
    title: 'El espacio y el equipamiento: todo lo que necesitás (y lo que no)',
    items: ['El mito del espacio especial para barre', 'La barra: tipos, materiales y montaje', 'El piso, los calcetines y los accesorios', 'Inversión inicial: el número real', 'Cómo recuperar la inversión en los primeros 60 días']
  }, {
    num: 3,
    title: 'Cómo estructurar una clase de barra de principio a fin',
    items: ['La anatomía de una clase de barra', 'El calentamiento', 'El trabajo en barra', 'El trabajo en el centro', 'El trabajo en el piso y la vuelta a la calma', 'Planificación mensual de clases']
  }, {
    num: 4,
    title: 'La música en el barre: cómo usarla para que tus clases vuelen',
    items: ['¿Por qué la música lo cambia todo en el barre?', 'BPM y estructura musical', 'Géneros y estilos que funcionan', 'Cómo armar tus propias listas de reproducción', 'Música y derechos: lo que toda dueña de estudio debe saber']
  }, {
    num: 5,
    title: 'Cómo lanzar tu clase de barre y llenarla desde el día uno',
    items: ['El lanzamiento que funciona vs el que queda en la nada', 'Tus alumnas actuales son tu primer público', 'Redes sociales: cómo comunicar sin parecer una ficha', 'Meta Ads para tu clase de barre', 'El boca a boca intencional', 'Métricas que importan en el primer mes']
  }, {
    num: 6,
    title: 'Gestión, precios y crecimiento de tu servicio de barre',
    items: ['Cómo ponerle precio a tu clase de barre', 'Sistemas de inscripción y cobro', 'Cómo retener alumnas a largo plazo', 'Escalar: de una clase a varias', 'Barre online: ¿vale la pena?', 'El barre como diferenciador de tu estudio']
  }];
  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-20 bg-barre-blush" data-id="element-160">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-161">
        <div className="text-center mb-12" data-id="element-162">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-163">
            ¿Qué incluye el Pack Digital?
          </h2>
          <p className="text-xl text-barre-pink font-medium" data-id="element-164">
            6 Tomos digitales con todo el conocimiento estructurado
          </p>
        </div>

        <div className="space-y-4" data-id="element-165">
          {tomos.map((tomo, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.05
          }} className={`bg-white rounded-2xl shadow-sm border overflow-hidden transition-all duration-300 ${isOpen ? 'border-barre-pink ring-1 ring-barre-pink shadow-md' : 'border-barre-border'}`} data-id="element-166">
                <button onClick={() => toggle(index)} aria-expanded={isOpen} className={`w-full flex items-center gap-4 p-5 sm:p-6 text-left transition-colors ${isOpen ? 'bg-barre-blush/30' : 'hover:bg-barre-blush/50'}`} data-id="element-167">
                  <div className={`w-11 h-11 rounded-full flex items-center justify-center text-lg font-bold flex-shrink-0 transition-colors ${isOpen ? 'bg-barre-pink text-white shadow-inner' : 'bg-barre-blush text-barre-pink border border-barre-border'}`} data-id="element-168">
                    {tomo.num}
                  </div>
                  <div className="flex-1" data-id="element-169">
                    <span className="block text-xs font-semibold uppercase tracking-wide text-barre-pink mb-0.5" data-id="element-170">
                      Tomo {tomo.num}
                    </span>
                    <h3 className="text-base sm:text-lg font-bold text-gray-900 leading-tight" data-id="element-171">
                      {tomo.title}
                    </h3>
                  </div>
                  <ChevronDown className={`w-5 h-5 text-barre-pink flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-172" />
                </button>

                <AnimatePresence initial={false} data-id="element-173">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} className="overflow-hidden bg-barre-blush/10" data-id="element-174">
                      <ul className="px-5 sm:px-6 pb-6 pl-16 space-y-3 pt-2" data-id="element-175">
                        {tomo.items.map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-700 font-medium" data-id="element-176">
                            <span className="mt-2 w-1.5 h-1.5 rounded-full bg-barre-pink flex-shrink-0" data-id="element-177" />
                            <span data-id="element-178">{item}</span>
                          </li>)}
                      </ul>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
};